const NUMERIC_PATTERN = '[0-9]*';
const DATE_PATTERN = '[0-9 \\-\\/]*';
export default {
  NUMERIC_PATTERN,
  DATE_PATTERN
};
//# sourceMappingURL=inputFieldPatterns.js.map